<template>
  <div class="examenes-container">
    <CardIeaAppMain colorCard="transparent" title="" class="premium-wrapper">
      <v-col cols="12" class="pa-0">
        
        <!-- Hero Header -->
        <div class="hero-header glass-panel mb-4 py-3 px-6 mx-2 mx-sm-4 mt-4">
          <div class="d-flex align-center justify-space-between w-100 flex-wrap">
            <div class="d-flex align-center mb-2 mb-md-0">
              <v-btn icon dark color="primary" class="mr-4 glass-btn" @click="$router.go(-1)">
                <v-icon>mdi-arrow-left</v-icon>
              </v-btn>
              <div>
                <h1 class="text-h5 font-weight-bold primary-text mb-0">{{ title }}</h1>
                <p class="text-caption grey--text text--darken-1 mb-0 d-none d-sm-block">Gestiona tus inscripciones y verifica el estado de tus mesas</p>
                <p class="text-caption grey--text text--darken-1 mb-0 d-block d-sm-none">Inscripción a Mesas</p>
              </div>
            </div>
            <v-icon size="48" color="primary" class="opacity-30 d-none d-sm-block">mdi-clipboard-text-outline</v-icon>
          </div>
        </div>

        <div v-for="(examenMesa, examenMesaKey) in examenes.data" :key="examenMesaKey" class="mx-2 mx-sm-4 mb-6">
          
          <!-- Mesa Info Header -->
          <v-card class="glass-card rounded-xl overflow-hidden mb-4" elevation="10">
            <div class="bg-light-gradient pa-4 pa-sm-6 border-bottom d-flex flex-column flex-md-row justify-space-between gap-4 align-md-center">
              <div>
                <h2 class="text-h6 font-weight-bold primary-text mb-1 d-flex align-center">
                  <v-icon color="primary" class="mr-2">mdi-calendar-multiselect</v-icon>
                  {{ examenes.curso }}
                </h2>
                <p class="text-subtitle-2 grey--text text--darken-1 mb-0">{{ examenMesa.curso.Feriado }}</p>
                
                <div class="d-flex align-center mt-3">
                  <v-chip class="font-weight-bold bg-white shadow-sm" outlined :color="examenMesa.cantidadInscipcion > 0 ? 'success' : 'grey'">
                    <v-icon left small>mdi-format-list-checks</v-icon>
                    Disponibles: {{ Math.max(0, examenMesa.cantidadInscipcion) }}
                  </v-chip>
                </div>
              </div>

              <div class="d-flex flex-column gap-2 align-md-end">
                <ModalSubsripcionExterna 
                  :inscripcionesDisponibles="examenMesa.cantidadInscipcionAntesDescuento" 
                  :montoXmateria="parseInt(examenMesa.montoXmateria)" 
                  :idMesa="parseInt(examenMesa.id)"
                  v-if="examenMesa.muestraBotonTolerancia && examenMesa.cantidadInscipcionAntesDescuento.length > 0" 
                />
                <v-btn color="error" rounded class="custom-btn-shadow font-weight-bold text-none" v-if="examenMesa.tieneDeudaGeneral" @click="pagarMontoDeuda(examenMesa.id)">
                  <v-icon left>mdi-currency-usd</v-icon> Pagar Deuda: ${{ examenMesa.montoDeudaGeneral }}
                </v-btn>
              </div>
            </div>
            
            <div class="pa-4 pa-sm-6 bg-light">
              <!-- No materias alert -->
              <v-alert type="info" prominent color="primary lighten-5" class="primary--text rounded-xl mb-0" elevation="0" v-if="!examenMesa.curso.plan_de_estudio_v2 || Object.keys(examenMesa.curso.plan_de_estudio_v2).length === 0">
                <v-icon left color="primary">mdi-information</v-icon> No hay materias disponibles en este plan de estudio.
              </v-alert>

              <!-- Materias List -->
              <div class="d-flex flex-column gap-3" v-else>
                <template v-for="(planDeEstudioData, planDeEstudioDataKey) in examenMesa.curso.plan_de_estudio_v2">
                  <v-card v-if="planDeEstudioData.tipo == 1 || planDeEstudioData.tipo == 3 || planDeEstudioData.tipo == 2 || planDeEstudioData.tipo == 4" :key="planDeEstudioDataKey" class="rounded-xl border-light bg-white hover-card overflow-hidden" elevation="0">
                    <div class="pa-4 pa-sm-5 d-flex flex-column flex-md-row justify-space-between gap-4">
                      
                      <!-- Materia Info -->
                      <div class="d-flex flex-grow-1 align-start">
                        <div class="icon-wrapper primary-light-bg mr-4 mt-1 flex-shrink-0">
                          <v-icon color="primary">mdi-book-open-page-variant-outline</v-icon>
                        </div>
                        <div class="w-100">
                          <h3 class="text-subtitle-1 font-weight-bold primary-text mb-2 line-height-1">{{ planDeEstudioData.Materia }}</h3>
                          
                          <!-- Motivo de Rechazo (Estado) -->
                          <template v-if="planDeEstudioData.motivo_rechazo && planDeEstudioData.validacion_pago == 'rechazada' && planDeEstudioData.rechazo_pago == 1 && planDeEstudioData.status != 0">
                            <v-chip small color="error" class="mb-2 font-weight-medium bg-error-light error--text" elevation="0"><v-icon small left color="error">mdi-alert-circle</v-icon> {{ planDeEstudioData.motivo_rechazo }}</v-chip>
                          </template>
                          <template v-else-if="planDeEstudioData.motivo_rechazo && planDeEstudioData.validacion_academica == 'rechazada' && planDeEstudioData.rechazo_pago === null && planDeEstudioData.status != 0">
                            <v-chip small color="error" class="mb-2 font-weight-medium bg-error-light error--text" elevation="0"><v-icon small left color="error">mdi-alert-circle</v-icon> {{ planDeEstudioData.motivo_rechazo }}</v-chip>
                          </template>
                          <template v-else-if="planDeEstudioData.motivo_rechazo && planDeEstudioData.rechazo_pago === null">
                            <v-chip small color="error" class="mb-2 font-weight-medium bg-error-light error--text" elevation="0"><v-icon small left color="error">mdi-alert-circle</v-icon> {{ planDeEstudioData.motivo_rechazo }}</v-chip>
                          </template>
                          <template v-else-if="planDeEstudioData.validacion_pago == 'rechazada' && planDeEstudioData.validacion_academica == 'rechazada' && planDeEstudioData.nuevo_monto_deuda <= 0 && planDeEstudioData.status != 0">
                            <v-chip small color="error" class="mb-2 font-weight-medium bg-error-light error--text" elevation="0"><v-icon small left color="error">mdi-alert-circle</v-icon> {{ planDeEstudioData.motivo_rechazo }}</v-chip>
                          </template>
                          
                          <!-- Validation Badges -->
                          <div class="d-flex flex-wrap gap-2 mt-1">
                            <!-- Academica -->
                            <template v-if="planDeEstudioData.validacion_academica == 'aceptada' && (planDeEstudioData.validacion_pago == 'aceptada' || planDeEstudioData.validacion_pago === null) && planDeEstudioData.status != 0">
                              <v-chip small color="success" outlined class="font-weight-bold bg-white"><v-icon small left>mdi-check-circle</v-icon> Valid. Académica</v-chip>
                            </template>
                            <template v-else-if="planDeEstudioData.validacion_academica == 'aceptada' && planDeEstudioData.nuevo_monto_deuda > 0 && planDeEstudioData.status != 0">
                              <v-chip small color="success" outlined class="font-weight-bold bg-white"><v-icon small left>mdi-check-circle</v-icon> Valid. Académica</v-chip>
                            </template>
                            <template v-else-if="planDeEstudioData.validacion_academica == 'rechazada' && planDeEstudioData.status != 0">
                              <v-chip small color="error" outlined class="font-weight-bold bg-white"><v-icon small left>mdi-close-circle</v-icon> Valid. Académica</v-chip>
                            </template>
                            
                            <!-- Pago -->
                            <template v-if="planDeEstudioData.nuevo_monto_deuda > 0 && planDeEstudioData.validacion_pago == 'rechazada' && planDeEstudioData.status != 0">
                              <v-chip small color="error" outlined class="font-weight-bold bg-white"><v-icon small left>mdi-close-circle</v-icon> Valid. Pago</v-chip>
                            </template>
                            <template v-else-if="btnDeshabilitadoDeuda == true && planDeEstudioData.validacion_pago == 'rechazada' && planDeEstudioData.status != 0">
                              <v-chip small color="error" outlined class="font-weight-bold bg-white"><v-icon small left>mdi-close-circle</v-icon> Valid. Pago</v-chip>
                            </template>
                            <template v-else-if="planDeEstudioData.validacion_pago == 'aceptada' && planDeEstudioData.status != 0">
                              <v-chip small color="success" outlined class="font-weight-bold bg-white"><v-icon small left>mdi-check-circle</v-icon> Valid. Pago</v-chip>
                            </template>
                            <template v-else-if="planDeEstudioData.validacion_pago == 'rechazada' && planDeEstudioData.validacion_academica == 'rechazada' && planDeEstudioData.nuevo_monto_deuda <= 0 && planDeEstudioData.status != 0">
                              <v-chip small color="success" outlined class="font-weight-bold bg-white"><v-icon small left>mdi-check-circle</v-icon> Valid. Pago</v-chip>
                            </template>
                          </div>
                        </div>
                      </div>

                      <!-- Actions -->
                      <div class="d-flex flex-column justify-center align-end min-w-max-content border-left-md pl-md-4 py-1 gap-2 action-container">
                        <div v-frag v-if="planDeEstudioData.tipo == 0">
                          <v-btn rounded class="font-weight-bold px-6 text-none" depressed color="grey lighten-3" disabled>Sin Mesa Aún</v-btn>
                        </div>
                        
                        <div v-frag v-if="planDeEstudioData.tipo == 1">
                          <div v-frag v-if="planDeEstudioData.diasUltimaInscripcion >= 550 && planDeEstudioData.excepcion_validacion == null">
                            <v-btn rounded class="custom-btn-shadow font-weight-bold px-6 text-none" color="primary" @click="exepcionValidacion(planDeEstudioData.IDStB, examenMesa.id)">Solicitar Excepcion</v-btn>
                          </div>
                          <div v-frag v-else-if="planDeEstudioData.diasUltimaInscripcion >= 550 && planDeEstudioData.excepcion_validacion.status == null">
                            <v-btn rounded class="font-weight-bold px-6 text-none" outlined color="primary">Esperando Confirmación</v-btn>
                          </div>
                          <div v-frag v-else-if="planDeEstudioData.diasUltimaInscripcion >= 550 && planDeEstudioData.excepcion_validacion.status == 0">
                            <v-btn rounded class="font-weight-bold px-6 text-none" color="error">Excepción Rechazada</v-btn>
                          </div>
                          <div v-frag v-else-if="btnDeshabilitadoDeuda == true && planDeEstudioData.diasUltimaInscripcion < 550">
                            <v-btn rounded class="font-weight-bold px-6 text-none" disabled color="success">Inscribir</v-btn>
                          </div>
                          <div v-else class="d-flex flex-column gap-2">
                            <v-btn v-show="extenderPeriodo == false && examenes.cantidad > 0 && examenMesa.cantidadInscipcion > 0" rounded class="custom-btn-shadow font-weight-bold px-6 text-none" color="success" @click="inscripcionMesaExamen(planDeEstudioData.IDStB, examenMesa.id, examenMesa.cantidadInscipcion)">Inscribir</v-btn>
                            <v-btn v-show="examenMesa.cantidadInscipcion == 0" rounded class="font-weight-bold px-6 text-none" disabled color="grey lighten-2">Sin cupo</v-btn>
                            <v-btn v-show="user.ext_mesas > 0" rounded class="custom-btn-shadow font-weight-bold px-6 text-none" color="success" @click="inscripcionMesaExamen(planDeEstudioData.IDStB, examenMesa.id)">Inscribir</v-btn>
                            <v-btn v-show="planDeEstudioData.status == 0" rounded class="custom-btn-shadow font-weight-bold px-6 text-none" color="success" @click="inscripcionMesaExamen(planDeEstudioData.IDStB, examenMesa.id)">Inscribir</v-btn>
                          </div>
                        </div>

                        <div v-frag v-if="planDeEstudioData.tipo == 2 && planDeEstudioData.status != 0">
                          <v-alert type="info" color="info lighten-5" class="info--text rounded-lg py-2 px-3 mb-0 border-light font-weight-medium text-caption d-flex flex-column align-center" elevation="0">
                            Esperando confirmación
                            <v-btn v-if="esFechaMenorOIgual(examenMesa.fechaTolerancia)" @click="cancelarInscripcionMesaExamen(planDeEstudioData.examen_inscipcion_alumno[0].id_validacion)" small rounded class="error--text text-decoration-underline font-weight-bold mt-2 text-none" text color="transparent">Cancelar</v-btn>
                          </v-alert>
                        </div>

                        <div v-frag v-if="planDeEstudioData.tipo == 3">
                          <div v-if="planDeEstudioData != null">
                            <div v-if="planDeEstudioData.examen_asociado != null && planDeEstudioData.examen_asociado.tipo_link == 0">
                              <v-btn rounded class="custom-btn-shadow font-weight-bold px-6 text-none" color="info" @click="linkPrueba(planDeEstudioData.examen_asociado.id_testpyr)">Prueba</v-btn>
                            </div>
                            <div v-else-if="planDeEstudioData.examen_asociado != null">
                              <v-btn rounded class="custom-btn-shadow font-weight-bold px-6 text-none white--text" color="#DB1D4A" :href="planDeEstudioData.examen_asociado.google_meet_url" target="_blank">ClassRoom</v-btn>
                            </div>
                            <div v-else>
                              <v-chip color="success" class="font-weight-bold px-4 rounded-pill">Inscripto</v-chip>
                            </div>
                          </div>
                          <div v-else>
                            <v-btn rounded class="font-weight-bold px-6 text-none" disabled color="grey lighten-3">Sin Mesa Aún</v-btn>
                          </div>
                        </div>

                        <div v-if="btnDeshabilitadoDeuda == false && planDeEstudioData.validacion_pago == 'rechazada' && (planDeEstudioData.validacion_academica == 'aceptada' || planDeEstudioData.validacion_academica === null) && planDeEstudioData.tipo != 4">
                          <v-btn v-show="examenes.cantidad > 0" rounded class="custom-btn-shadow font-weight-bold px-6 text-none" color="success" @click="inscripcionMesaExamen(planDeEstudioData.IDStB, examenMesa.id)">Inscribir</v-btn>
                        </div>

                        <div v-if="planDeEstudioData.status == 0 && planDeEstudioData.tipo == null">
                          <v-btn v-show="examenes.cantidad > 0" rounded class="custom-btn-shadow font-weight-bold px-6 text-none" color="success" @click="inscripcionMesaExamen(planDeEstudioData.IDStB, examenMesa.id)">Inscribir</v-btn>
                        </div>

                        <div v-frag v-else-if="planDeEstudioData.tipo == 4">
                          <v-chip color="error" class="font-weight-bold px-4 rounded-pill">Rechazado</v-chip>
                        </div>
                        
                      </div>
                    </div>
                  </v-card>
                </template>
              </div>
            </div>
          </v-card>
        </div>
      </v-col>
    </CardIeaAppMain>
  </div>
</template>
<script>
import CardIeaAppMain from "../../components/CardIeaAppMain";
import ModalSubsripcionExterna from "../../components/ModalSubsripcionExterna.vue"
export default {
    name: "InscripcionExamen",
    components: {
        CardIeaAppMain,
        ModalSubsripcionExterna
    },
    data() {
        return {
            title: "Tus Inscripciones a Exámenes",
            examenes: [],
            inscripcionesDisponibles: [],
            btnDeshabilitadoDeuda: false,
            extenderPeriodo: false,
        }
    },
    computed: {
        user() {
            return this.$store.getters.user;
        }
    },
    methods: {
        async inscripcionMesaExamen(examen, mesa, cantidadInscripcion) {
            await this.$API
                .post({
                    url: "examen/mesas-inscripcion-new",
                    data: {
                        materia_id: examen,
                        examenMesa_id: mesa,
                        cantidadInscripcion: cantidadInscripcion
                    }
                })
                .then(() => {
                    this.mesaDeExamen();
                });
        },
        async cancelarInscripcionMesaExamen(id) {
            await this.$API
                .post({
                    url: "examen/cancelar-inscripcion",
                    data: {
                        id: id
                    }
                })
                .then(() => {
                    this.mesaDeExamen();
                });
        },
        async pagarMontoDeuda(id_mesa) {
            console.log(id_mesa);
            let dataSend = {
                // id_inscripcion:id_inscripcion,
                id_mesa: id_mesa,
                alumno: this.user.IDStB
                // id_validacion:id_validacion
            };

            let url = "mobbex/mobbex-pago-deuda-examen";
            this.$API
                .post({
                    url: url,
                    data: dataSend
                })
                .then(res => {
                    location.href = res.data.url;
                });
        },
        async exepcionValidacion(materia, mesa) {
            await this.$API
                .post({
                    url: "exepcion-validacion-inscripcion",
                    data: {
                        materia_id: materia,
                        mesa_id: mesa
                    }
                })
                .then((res) => {
                    console.log(res)
                    this.mesaDeExamen();
                });
        },
        esFechaMenorOIgual(fecha) {
            const fechaTolerancia = new Date(fecha);
            const fechaActual = new Date();
            return fechaTolerancia >= fechaActual;
        },
        linkPrueba(idPrueba) {
            this.$router.push({
                name: "examen",
                params: {
                    test: idPrueba
                }
            });
        },
        async mesaDeExamen() {
            await this.$API
                .get({
                    url: "examen/mesas",
                    data: {}
                })
                .then(res => {
                    for (let index = 1; index <= res.cantidad; index++) {
                        this.inscripcionesDisponibles.push(index);
                    }
                    this.examenes = res;

                    this.btnDeshabilitadoDeuda = res.data.some(curso => {
                        const materias = Object.values(curso.curso.plan_de_estudio_v2);
                        return materias.some(materia => materia.rechazo_pago === 1);
                    });
                });
        },
    },
    mounted() {
        this.mesaDeExamen()
    },
}
</script>

<style scoped>
/* Glassmorphism Classes (Premium UI) */
.examenes-container { background: transparent !important; min-height: calc(100vh - 120px); }
.glass-panel { background: rgba(255, 255, 255, 0.7) !important; backdrop-filter: blur(16px) !important; border: 1px solid rgba(255, 255, 255, 0.5) !important; box-shadow: 0 8px 32px 0 rgba(31, 38, 135, 0.05) !important; border-radius: 20px; padding: 24px; }
.glass-card { background: rgba(255, 255, 255, 0.85) !important; backdrop-filter: blur(16px) !important; border: 1px solid rgba(255, 255, 255, 0.4) !important; }
.glass-btn { background: rgba(25, 118, 210, 0.1) !important; backdrop-filter: blur(4px) !important; box-shadow: none !important; transition: all 0.3s ease; }
.glass-btn:hover { background: rgba(25, 118, 210, 0.2) !important; transform: translateY(-2px); }
.bg-light { background-color: #f8fafc !important; }
.bg-light-gradient { background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%); }
.bg-error-light { background-color: #ffebee !important; }
.border-light { border: 1px solid rgba(0, 0, 0, 0.05) !important; }
.border-bottom { border-bottom: 1px solid rgba(0, 0, 0, 0.05) !important; }
.hover-card { transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1); border-left: 4px solid transparent; }
.hover-card:hover { transform: translateY(-4px); box-shadow: 0 12px 24px -8px rgba(0, 0, 0, 0.12) !important; border-left-color: var(--v-primary-base, #1976d2); }
.shadow-premium { box-shadow: 0 10px 30px -10px rgba(0,0,0,0.08) !important; }
.custom-btn-shadow { box-shadow: 0 8px 20px -6px rgba(25, 118, 210, 0.4) !important; transition: all 0.3s ease; }
.custom-btn-shadow:hover { transform: translateY(-2px); box-shadow: 0 12px 25px -6px rgba(25, 118, 210, 0.5) !important; }

/* Utilities */
.gap-1 { gap: 4px; }
.gap-2 { gap: 8px; }
.gap-3 { gap: 12px; }
.gap-4 { gap: 16px; }
.line-height-1 { line-height: 1.2; }
.primary-text { color: #1e293b; }
.opacity-30 { opacity: 0.3; }
.min-w-max-content { min-width: max-content; }
.w-100 { width: 100%; }

/* Custom elements */
.icon-wrapper { width: 48px; height: 48px; border-radius: 12px; display: flex; align-items: center; justify-content: center; }
.primary-light-bg { background-color: rgba(25, 118, 210, 0.08); }

@media (min-width: 960px) {
  .border-left-md { border-left: 1px solid rgba(0, 0, 0, 0.05) !important; }
}
.action-container .v-btn { width: 100%; justify-content: center; }
</style>